export default "__VITE_ASSET__CTW2gYJ9__"